/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import OverlayError from "components/OverlayError";
import { Helmet } from "react-helmet";

export default function NoAppPage() {
  return (
    <>
      <Helmet>
        <script src="https://static.classdojo.com/radiant-media-player/js/rmp.min.js" key="rmp" />
      </Helmet>
      <OverlayError />
    </>
  );
}
